var map = {
	"./cn": [
		"1b03",
		"chunk-2d0b5d0a"
	],
	"./cn.json": [
		"1b03",
		"chunk-2d0b5d0a"
	],
	"./en": [
		"e312",
		"chunk-2d225005"
	],
	"./en.json": [
		"e312",
		"chunk-2d225005"
	],
	"./kh": [
		"a346",
		"chunk-2d207eea"
	],
	"./kh.json": [
		"a346",
		"chunk-2d207eea"
	],
	"./kr": [
		"c708",
		"chunk-2d217632"
	],
	"./kr.json": [
		"c708",
		"chunk-2d217632"
	],
	"./la": [
		"2f00",
		"chunk-2d0be06a"
	],
	"./la.json": [
		"2f00",
		"chunk-2d0be06a"
	],
	"./th": [
		"5b02",
		"chunk-2d0d2e85"
	],
	"./th.json": [
		"5b02",
		"chunk-2d0d2e85"
	],
	"./validator/en": [
		"4b5a"
	],
	"./validator/en.json": [
		"4b5a"
	],
	"./validator/la": [
		"1554"
	],
	"./validator/la.json": [
		"1554"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "5892";
module.exports = webpackAsyncContext;